export default "__VITE_ASSET__55b6d1d2__"